import { api as virtualGroupApi } from '../hooks/virtualgroup'
import { api as financialApi } from '../hooks/financial'

import { createDocument } from './documents'

export const TOKEN_KEY = 'auth-token'
export const USER_DATA = 'auth-user'

export const getToken = () => localStorage.getItem(TOKEN_KEY)

export const getUser = () => localStorage.getItem(USER_DATA)

export const login = ({ token, user }) => {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_DATA, JSON.stringify(user))
}

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_DATA)
}

export const createAuthentication = async (user) => {
  const data = await createDocument(user, 'login')

  // implement isUserAuthenticated on login
  if (data.type === 'success' && data.data.token !== null && data.data.user?.permissions?.length && !data.data.twoFactorRequired) {
    login(data.data)

    virtualGroupApi.defaults.headers.Authorization = `Bearer ${data.data.token}`
    financialApi.defaults.headers.Authorization = `Bearer ${data.data.token}`
  }
  return data
}

export const sendCode = async (form) => {
  const data = await createDocument(form, 'forgotpassword/sendCode')

  return data
}

export const changePassword = async (form) => {
  const data = await createDocument(form, 'forgotpassword/change')

  return data
}

export const verifyTwoFactorCode = async (form) => {
  const data = await createDocument(form, '2fa/verify')

  if (data.type === 'success' && data.data.token !== null && data.data.user?.permissions?.length) {
    login(data.data)

    virtualGroupApi.defaults.headers.Authorization = `Bearer ${data.data.token}`
    financialApi.defaults.headers.Authorization = `Bearer ${data.data.token}`
  }
  return data
}

export const resendTwoFactorCode = async (form) => {
  const data = await createDocument(form, '2fa/resend')
  return data
}
